import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { useGetVerbConjugationQuery } from '@/api';
import Page from '@/modules/component/Page';
import PageMeta from '@/modules/component/PageMeta';
import { registerLocaleResources, useCommonTranslation, useTranslation } from '@/modules/i18n/useTranslation';

import en from './locales/en.json';
import es from './locales/es.json';
import ru from './locales/ru.json';
import VerbTable from './VerbTable';
import { DEFAULT_VERB, normalizeVerb, PREPARED_VERBS } from './verbs';

registerLocaleResources('GlagolEspanolPage', { en, es, ru });

declare module '@/modules/i18n/namespaces' {
    interface LocaleNamespaces {
        GlagolEspanolPage: typeof en;
    }
}

const GlagolEspanolPage = () => {
    const { t } = useTranslation('GlagolEspanolPage');
    const { t: tCommon } = useCommonTranslation();
    const [verb, setVerb] = useState(DEFAULT_VERB);
    // data, not currentData: the previous verb's table stays on screen while the next one loads or fails
    const { data: conjugation, isError } = useGetVerbConjugationQuery(verb);
    const title = t('title');

    const changeVerb = (input: string) => {
        const nextVerb = normalizeVerb(input);
        if (nextVerb) {
            setVerb(nextVerb);
        }
    };

    return (
        <Page>
            <PageMeta title={title}/>
            <Typography component="div" align="left">
                <h1>{title}</h1>
                <Alert>
                    {t('about.projection')}
                    <br/>
                    {t('about.caveat')}
                </Alert>
                <br/>
                <Alert severity={'warning'}>{t('warning')}</Alert>
                {isError && (
                    <>
                        <br/>
                        <Alert severity="error">{tCommon('error.unknown')}</Alert>
                    </>
                )}
            </Typography>
            {conjugation && (
                <VerbTable conjugation={conjugation} words={PREPARED_VERBS} onChangeVerb={changeVerb}/>
            )}
        </Page>
    );
};

export default GlagolEspanolPage;
